export const safetyPageDefaults = {
  heroBadge: 'PRÓXIMAMENTE EN ESLIPIN',
  heroTitle: 'SEGUROS',
  heroSubtitle: 'Tu tranquilidad\ntambién viaja con nosotros',
  heroDescription: 'Estamos trabajando en una solución de **seguros**, para que pueda hospedarte y recibir huéspedes con aún más tranquilidad.',
  heroBackgroundImage: '/SliderVideo/BannerTwo.jpeg',
  feature1Title: 'Más tranquilidad',
  feature1Description: 'Para tus viajes\ny tus reservas.',
  feature1Icon: '',
  feature2Title: 'Protección real',
  feature2Description: 'Pensada para huéspedes\ny anfitriones.',
  feature2Icon: '',
  feature3Title: 'La misma confianza',
  feature3Description: 'Con el respaldo\nde Eslipin.',
  feature3Icon: '',
  bottomCardTitle: 'Estamos construyendo\nmás seguridad para tu alojamiento',
  bottomCardText: 'Queremos que cada experiencia en Eslipin sea simple, clara y segura. Pronto podrás contar con opciones de seguros que se adapten a tus necesidades, tanto si te alojas como si recibes huéspedes.',
};

const allowedKeys = Object.keys(safetyPageDefaults);

export const mergeSafetySettings = (rows = []) => {
  const settings = { ...safetyPageDefaults };

  (rows || []).forEach(({ name, value }) => {
    if (allowedKeys.includes(name) && value !== null && value !== undefined) {
      settings[name] = value;
    }
  });

  return settings;
};
